import React from 'react';
import LawsuitFilingPage from '../LawsuitFilingPage';

const FileLawsuitPage: React.FC = () => {
  return <LawsuitFilingPage />;
};

export default FileLawsuitPage; 